import { render, staticRenderFns } from "./more-person-identifier.html?vue&type=template&id=5ab5a9ad&scoped=true&"
import script from "./more-person-identifier.js?vue&type=script&lang=js&"
export * from "./more-person-identifier.js?vue&type=script&lang=js&"
import style0 from "./more-person-identifier.scss?vue&type=style&index=0&id=5ab5a9ad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab5a9ad",
  null
  
)

export default component.exports